// Stable topic keys: the labels shown to visitors live in `@/constants/translations`.
export const CONTACT_TOPICS = ['internship', 'work-study', 'project', 'hello'] as const

export const CONTACT_LIMITS = {
    name: 100,
    email: 254,
    messageMin: 10,
    messageMax: 4000
}

export const EMAIL_PATTERN = /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:"]{2,}$/
